import { useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";

import { standardCheckoutRoutes } from "@jti/fe-common";
import { useSelector } from "@jti/store/reduxHooks";
import { useTranslations } from "@jti/ui";

import { CheckoutAside } from "@checkout/components/CheckoutAside";
import { CheckoutProgressGtmObserver } from "@checkout/components/CheckoutProgressGtmObserver";
import { HeaderWithBreadcrumbs } from "@checkout/components/HeaderWithBreadcrumbs";
import { CheckOutSteps } from "@checkout/constants/checkout-constants";
import { useFreeTrial } from "@checkout/hooks/useFreeTrial";
import { useRedirectToTrialProductsFromTrialCheckout } from "@checkout/hooks/useRedirectToTrialProductsFromTrialCheckout";
import { PageBaseLayout } from "@checkout/layouts/PageBaseLayout";

import { DeliveryPageContent } from "./components/DeliveryPageContent";

export const DeliveryPage = () => {
  useRedirectToTrialProductsFromTrialCheckout();

  const { __ } = useTranslations();
  const history = useHistory();
  const { isFreeTrial } = useFreeTrial();
  const asideSubmitButtonWrapperRef = useRef<HTMLDivElement>(null);

  const { shippingStepData } = useSelector((state) => state.standardCheckoutForm);

  useEffect(() => {
    if (!shippingStepData) {
      history.replace(standardCheckoutRoutes.root);
    }
  }, [shippingStepData]);

  return (
    <>
      <CheckoutProgressGtmObserver step={CheckOutSteps.Delivery} />
      <PageBaseLayout
        header={
          <HeaderWithBreadcrumbs
            title={__(!isFreeTrial ? "cart.title.checkout" : "cart.title.freeTrial")}
            step={CheckOutSteps.Delivery}
          />
        }
        content={<DeliveryPageContent asideSubmitButtonWrapperRef={asideSubmitButtonWrapperRef} />}
        aside={<CheckoutAside submitButtonWrapperRef={asideSubmitButtonWrapperRef} step={CheckOutSteps.Delivery} />}
        data-testid="delivery-page"
      />
    </>
  );
};
